import { Input } from '@chakra-ui/input';
import { Button } from '@chakra-ui/button';
import React, {useEffect, useState} from 'react';
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone } from 'react-icons/hi';
import { RiLockPasswordFill, RiLockPasswordLine } from 'react-icons/ri';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../context/auth';
import { useToast } from '@chakra-ui/react';
import { MdOutlinePhoneIphone } from 'react-icons/md';

const NewHome = () => {
    const toast = useToast();
    const { login, currentUser } = useContext(AuthContext);
    const navigate = useNavigate();
    const [user, setUser] = useState({ depo_and_phone: "", password: "" });
    const [loading, setLoading]= useState(false);

    useEffect(() => {
        // if(currentUser !== null){
        //     navigate('/profile');
        // }
    }, []);
    

    const nav = () => {
        navigate('/profile');
    }

    const HandleSubmit = async e => {
        if(user.depo_and_phone === "" || user.password === ""){
          return toast({title: 'Мэдээлэл дутуу',description: "Таны мэдээлэл дутуу байна",status: 'warning',duration: 9000,isClosable: true,}) 
        }
        setLoading(true);
        await login(user)
        setLoading(false);
    }

  return (
    <div className='bg-back w-full h-screen bg-cover'>
        <div className='w-full font-Roboto flex justify-center items-center'>
            <div className='flex flex-col justify-center xs:w-full xs:mx-2 md:w-1/4'>
                <div className='flex justify-center py-8'>
                    <img className='xs:h-20 md:h-40 rounded-full p-1 bg-white' src='../4.png'/>
                </div>
                <div className='bg-white rounded-md py-8 px-8'>
                    <div className=''>
                        <h1 className='text-xl text-center font-bold uppercase'>skyhouse</h1>
                    </div>
                    <div>
                        <div className='flex items-center  mt-3'>
                            <div className='bg-white rounded-md border p-2'>
                                <MdOutlinePhoneIphone size={16} className=''/>
                            </div>
                            <Input 
                            value={user.depo_and_phone}
                            onChange={ e => setUser({...user, depo_and_phone:e.target.value})} 
                            type='number' 
                            placeholder='Утасны дугаар' className='ml-1 bg-slate-100 placeholder:text-sm'/>
                        </div>

                        <div className='flex items-center  mt-3'>
                            <div className='bg-white rounded-md border p-2'>
                                <RiLockPasswordFill size={16} className=''/>
                            </div>
                            <Input
                            value={user.password}
                            onChange={ e => setUser({...user, password:e.target.value})}
                            type='password'  placeholder='Пин код' className='ml-1 bg-slate-100 placeholder:text-sm'/>
                        </div>

                  

                        {
                            loading?
                            <Button className='w-full mt-8 uppercase hover:bg-[#122952]' textColor='white' bg='#402978'>
                                Шалгаж байна ...
                            </Button>
                            :
                            <Button onClick={HandleSubmit} className='w-full mt-8 uppercase hover:bg-[#122952]' textColor='white' bg='#402978'>
                                Нэвтрэх
                            </Button>
                        }

                        <Link to='/register' className='text-blue-800 text-center mt-4'>
                            {/* <Button className='w-full mt-1 uppercase hover:bg-[#053262]' textColor='white' bg='blue'> */}
                                {/* Facebook group */}
                            {/* </Button> */}
                            <h1 className='mt-4 font-bold'>Бүртгүүлэх</h1>
                        </Link>
                        {/* <a href='https://www.facebook.com/groups/256707968539336/' target="_blank" className='text-blue-800 text-center mt-4'>
                            <h1 className='mt-8 font-bold'>Facebook group</h1>
                        </a> */}
                    </div>
                </div>
            </div>
        </div>
      
        <div>
            <h1 className='text-white font-Roboto text-sm text-center mt-20 font-bold uppercase'>Giilen.mn бүтээв</h1>
        </div>
    </div>
  )
}

export default NewHome
